import i18n from '@/locale/index'

export default [
  {
    path: '/wolfTerms',
    name: 'wolfTerms',
    component: () => import('../../views/metaTerm/wolfTerms.vue'),
    meta: {
      title: i18n.global.t('wolfTerms.title'),
    }
  },
 
]